/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snapshot_History_Close_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Close modal" |
*
* @param {Snapshot_History_Close_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snapshot_history_close_aria_label = /** @type {((inputs?: Snapshot_History_Close_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snapshot_History_Close_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la boite de dialogue")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modal schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi modale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar modal")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭模态框")
	if (locale === "ja") return /** @type {LocalizedString} */ ("モーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar modal")
	return /** @type {LocalizedString} */ ("Close modal")
});